import OverlayNotificationModal from 'components/OverlayNotificationModal';
import { UserContext } from 'contexts/user/UserContextProvider';
import { useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import menuItems from '../constants/mainMenu';
import Sidebar from '../containers/navs/Sidebar';
import TopNav from '../containers/navs/Topnav';

const AppLayoutNoFooter = ({ containerClassnames, children, history }) => {
  const { currentUser, showOverlayNotificationModal } = useContext(UserContext);

  return (
    <div id="app-container" className={containerClassnames}>
      {showOverlayNotificationModal && <OverlayNotificationModal />}
      <TopNav history={history} />
      <Sidebar name="Main" menuItems={menuItems} currentUser={currentUser} />
      <main>
        <div className="container-fluid">
          {children}
        </div>
      </main>
    </div>
  );
};
const mapStateToProps = ({ menu }) => {
  const { containerClassnames } = menu;
  return { containerClassnames };
};
const mapActionToProps = {};

export default withRouter(connect(mapStateToProps, mapActionToProps)(AppLayoutNoFooter));
